<template>
  <v-toolbar flat rounded height="73" class="new-chat-header-toolbar">
    <div class="new-chat-header-toolbar-wrapper">
      <v-btn icon v-if="step % 2 !== 1" @click="$emit('onPreviousStep')">
        <v-icon>
          mdi-chevron-left
        </v-icon>
      </v-btn>
      <v-toolbar-title class="new-chat-header-toolbar-title">
        {{ toolbarTitle }}
        <p class="new-chat-header-toolbar-subtitle">
          {{ toolbarSubtitle }}
        </p>
      </v-toolbar-title>
    </div>
    <v-spacer></v-spacer>
    <v-btn color="accent" icon tile @click="$emit('closeDialog')">
      <v-icon size="24">mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: 'NewChatDialogHeaderToolbar',
  props: {
    step: {
      type: Number,
      default: 0,
    },
    selectedContacts: {
      type: Array,
      default: () => [],
    },
    participantsSummary: {
      type: String,
      default: '',
    },
  },
  computed: {
    toolbarTitle() {
      return this.step > 2 ? 'Edit chat' : 'New chat'
    },
    toolbarSubtitle() {
      return this.step % 2 === 1
        ? this.selectedContacts.length
          ? this.participantsSummary
          : this.step === 1
          ? 'Add chat members'
          : 'Edit chat members'
        : this.step === 2
        ? 'Add subject'
        : 'Edit subject'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.new-chat-header-toolbar {
  &-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    .v-btn {
      margin-top: 7px;
    }
    ::v-deep .v-btn--outlined .v-btn__content .v-icon,
    .v-btn--round .v-btn__content .v-icon {
      color: $bh-blue;
      padding: $gutter;
      font-size: 1.5rem;
    }
  }
  &-title {
    font-weight: bold;
    color: $bh-blue;
    padding: 18px 9px 0;
    font-size: 1.5715rem;
    line-height: 1.2;
  }
  &-subtitle {
    color: $bh-blue;
    font-size: 0.85714rem;
    margin: 0;
    font-weight: normal;
  }
}
</style>
